import numerate from '@/utils/numerate'

export default function (value = 0, variants) {
    return numerate(variants, value)
}
